/* src/app/main/pages/home-page/component/home-banner/home-banner.component.css */
.home-banner-video,
.home-banner-image {
  display: flex;
  align-items: center;
}
.banner-overlap-text {
  position: absolute;
  color: #fff;
  width: 100%;
}
.home-banner-video .banner-overlap-text h1 {
  font-size: 56px;
}
.home-banner-video .banner-overlap-text p,
.home-banner-image .banner-overlap-text p {
  font-family: "D-DIN-Bold";
  font-size: 31.9px;
  font-weight: 600;
}
#bg_container {
  height: 600px;
  overflow: hidden;
  width: 100%;
}
#bg,
#bg-1 {
  width: 100%;
}
.home-banner-image {
  display: none;
}
@media (min-device-width: 1600px) {
  .home-banner-video .banner-overlap-text h1 {
    font-size: 89px;
  }
  .home-banner-video .banner-overlap-text p {
    font-size: 50.9px;
  }
  #bg_container {
    height: 810px;
  }
}
@media (min-device-width: 1200px) and (max-device-width: 1366px) {
  #bg_container {
    height: 600px;
  }
}
@media (max-device-width: 1024px) {
  #bg_container {
    height: auto;
  }
}
@media (min-device-width: 768px) {
  #bg {
    display: block;
  }
  .video-replace-banner {
    display: none;
  }
}
@media (max-device-width: 767px) {
  .home-banner-video .banner-overlap-text h1,
  .home-banner-image .banner-overlap-text h1 {
    font-size: 36px;
  }
  .home-banner-video .banner-overlap-text p,
  .home-banner-image .banner-overlap-text p {
    font-size: 20px;
  }
  #bg,
  .home-banner-video {
    display: none;
  }
  .video-replace-banner {
    display: block;
  }
  .home-banner-image {
    display: flex;
  }
}
@media (max-device-width: 355px) {
  .home-banner-video .banner-overlap-text h1,
  .home-banner-image .banner-overlap-text h1 {
    font-size: 32px;
  }
  .home-banner-video .banner-overlap-text p,
  .home-banner-image .banner-overlap-text p {
    font-size: 18px;
  }
}
@media all and (-ms-high-contrast: none) {
  .home-banner-video {
    display: block !important;
  }
  .banner-overlap-text {
    z-index: 999;
    top: 300px;
  }
}
/*# sourceMappingURL=home-banner.component.css.map */
